export default __webpack_public_path__ + "static/media/longCloud11.a8118df9.png";